import React, { useContext } from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import ProductDetailContext from "@micado-digital/react-shop/ProductDetail/context/ProductDetailContext";
import ProductTag from "../../../components/Tag";

import styles from "./Tag.styles";

const Tag = () => {
	const { productDetailData } = useContext(ProductDetailContext);
	const { awardTag } = productDetailData || {};
	const css = styles();

	if (isEmpty(awardTag)) return <></>;

	return (
		<div className={clsx(css.tag, "mco-shop-product-detail-tag")}>
			<ProductTag tag={awardTag} />
		</div>
	);
};

export default Tag;
